export default {
    pageTitle: 'Dados exportados',
    requestedBy: 'Solicitado por',
    date: 'Data',
    type: 'Tipo',
    equipmentReplicatedServicesReport: 'Serviços do equipamento',
    equipmentReplicatedServicesReportHover: 'Último serviço realizado por tipo de serviço do equipamento',
    completed: 'Completado',
    failed: 'Falhou',
    scheduled: 'Agendado',
    processing: 'Processando',
    equipmentReplicatedServicesWithAttachmentsReport: 'Serviços do equipamento com anexos',
    equipmentReplicatedServicesWithAttachmentsReportHover: 'Último serviço realizado por tipo de serviço do equipamento com anexos',
}